export const PHONE_NUMBER = `1-855-793-9727`;
export const FAX_NUMBER = `1-866-329-9775`;
export const ESCALATION_EMAIL = 'exparelpro.com';

export const dataProduct = [
  {
    "id": 15,
    "name": "Exparel 133mg/10ml vial",
    "ndc": "65250013310"
},
{
    "id": 16,
    "name": "Exparel 266mg/20ml vial",
    "ndc": "65250026620"
}
];

export const SITE_OF_CARE = [
  {
    name: "11-Physician office/clinic",
    value: "11-Physician office/clinic",
  },
  {
    name: "24-Ambulatory Surgery Center",
    value: "24-Ambulatory Surgery Center",
  },
  {
    name: "19-Hospital Outpatient Department (Off-campus)",
    value: "19-Hospital Outpatient Department (Off-campus)",
  },
  {
    name: "22-Hospital Outpatient Department (On-campus)",
    value: "22-Hospital Outpatient Department (On-campus)",
  },
  {
    name: "Other",
    value: "other",
  },

];
